// extracted by mini-css-extract-plugin
module.exports = {"root":"Arrows_root__3c5H_","container":"Arrows_container__3yuT8","left":"Arrows_left__3S4-a","right":"Arrows_right__36dNy"};